
import EolList from './EolList';
import EolCRU from './EolCRU';
export { EolList, EolCRU };

export const eolOptionObj = {
    lease_option: null,
    validity_start_date: null,
    validity_end_date: null,
    notice_period_start_date: null,
    notice_period_end_date: null,
    extension_start_date: null,
    extension_end_date: null,
    extension_rate_type: null,
    is_extension_applicable:false

}